import {
  combineReducers,
} from 'redux';
import {
  routerReducer,
} from 'react-router-redux';

import Auth from './Auth.js';
import Specification from './Specification.js';
import Selection from './Selection.js';
import Simulator from './Simulator.js';
import Detection from './Detection.js';
import Reservation from './Reservation.js';
import Map from './Map.js';

export default combineReducers({
  Auth,
  Specification,
  Selection,
  Simulator,
  Detection,
  Reservation,
  Map,
  routing: routerReducer,
});



// WEBPACK FOOTER //
// ./reducers/index.js